module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-cal__subjects no-print",
    class: {
      'd-cal__subjects--dragging': _vm.isDraggingSubject
    },
    on: {
      "pointerenter": _vm.onMouseEnter,
      "pointerleave": _vm.onMouseLeave
    }
  }, [_c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.deleteSubject) ? _c('div', {
    staticClass: "d-cal__subjects--trashcan",
    class: {
      'd-cal__subjects--trashcan--hovered': _vm.isDCalATrashcan
    }
  }, [_c('div', {
    staticClass: "icon-bin"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue2.common.delete')) + " " + _vm._s(_vm.deleteSubject.title))])]) : _vm._e()]), _vm._v(" "), _c('CreateSubject', {
    attrs: {
      "calendarId": _vm.calendarId,
      "isInDCalendar": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-cal__subjects__container"
  }, [(_vm.isShowImportSubjectsOption) ? _c('ImportSubjectsToKlass', {
    attrs: {
      "calendarId": _vm.calendarId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSubjectsLoading) ? _c('Loader', {
    staticClass: "d-cal__subjects__container__loader",
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "d-acc"
  }, _vm._l((_vm.subjectsInCategoriesSorted), function(subjectsCat) {
    return _c('li', {
      key: subjectsCat.type,
      staticClass: "d-acc__container",
      class: {
        'd-acc__container--closed': _vm.theActiveAcc !== subjectsCat.type
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheActiveAcc(subjectsCat.type)
        }
      }
    }, [_c('h4', [_vm._v(_vm._s(subjectsCat.v_title))]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "accordion"
      },
      on: {
        "enter": _vm.startTrans,
        "after-enter": _vm.endTrans,
        "before-leave": _vm.startTrans,
        "after-leave": _vm.endTrans
      }
    }, [(_vm.theActiveAcc === subjectsCat.type) ? _c('div', [_c('transition-group', {
      staticClass: "d-acc__container__body",
      attrs: {
        "name": "list-complete",
        "tag": "ul"
      }
    }, _vm._l((_vm.activeSubjects), function(subject) {
      return _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: (_vm.tippySettings(subject)),
          expression: "tippySettings(subject)"
        }],
        key: subject.id,
        staticClass: "list-complete-item d-cal__subjects__subject",
        class: {
          'd-cal__subjects__subject--not-editable': !subject.v_is_editable
        },
        style: ([{
            'borderColor': subject.color
          },
          {
            'backgroundColor': subject.color
          }
        ]),
        attrs: {
          "subject": subject,
          "content": _vm.tippyContent(subject),
          "draggable": "false"
        },
        on: {
          "dragstart": function($event) {
            $event.preventDefault();
          },
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
          },
          "pointerdown": function($event) {
            $event.preventDefault();
            return _vm.onMouseDown(subject, $event)
          }
        }
      }, [_c('div', {
        staticClass: "d-cal__subjects__subject__left"
      }, [_vm._v("\n                  " + _vm._s(subject.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "d-cal__subjects__subject__right"
      }, [(subject.v_must_have_teacher && subject.v_cal_types.users.length < 1) ? _c('div', {
        staticClass: "subject-draggable__slider"
      }, [_c('div', {
        staticClass: "d-cal__subjects__subject__subject_info"
      }, [_vm._v("\n                      " + _vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "d-cal__subjects__subject__remember-teacher"
      }, [_c('span', {
        staticClass: "icon-user3"
      }), _vm._v(_vm._s(_vm.i18n[_vm.locale]['add']) + "\n                    ")])]) : _c('div', {
        staticClass: "d-cal__subjects__subject__subject_info"
      }, [(subject.v_hours) ? [_vm._v(_vm._s(subject.v_hours) + _vm._s(_vm.i18n[_vm.locale]['hours_per_year']) + "\n                    ")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
        staticClass: "subject__details"
      }, [(subject.v_cal_types.rooms.length > 0) ? _c('span', {
        staticClass: "icon-location"
      }) : _vm._e(), _vm._v(" "), (subject.v_cal_types.users.length > 0) ? _c('span', {
        staticClass: "icon-user"
      }) : _vm._e()])])
    }), 0)], 1) : _vm._e()])], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1198c775!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarSubjects.vue
// module id = 1765
// module chunks = 1